import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setChatPageContext } from '|/app/purchase/checkout/constants/chat-page-context';
import { getChatSurface } from '|/app/purchase/checkout/constants/chat-surface-mappings';
import { StepName } from '|/app/services';
import { useSlate } from '|/context';

const useChatPageContext = (stepUrl: string, stepId: StepName | null) => {
  const { pathname } = useLocation();
  const { isSlateVehicle } = useSlate();

  useEffect(() => {
    if (!pathname.includes('/steps/')) return;
    const surface =
      getChatSurface(stepUrl, isSlateVehicle) ?? getChatSurface(stepId ?? '', isSlateVehicle);
    if (!surface) return;
    setChatPageContext(surface);
  }, [stepUrl, stepId, pathname, isSlateVehicle]);
};

export default useChatPageContext;
